<template>
    <div class="info-container">
        <apex-charts width="400" type="donut" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
    import ApexCharts from 'vue-apexcharts'
    import { MSG_STATUS_COLORS } from '@/utils/consts'

    export default {
        components: { ApexCharts },
        props: {
            statusCounts: {
                type: Array,
                required: false,
                default: () => []
            },
            chartTitle: {
                type: String,
                required: false,
                default: ''
            }
        },
        data() {
            return {
                statusCountsMap: new Map(),
                chartOptions: {
                    colors: [],
                    chart: {
                        type: 'donut',
                        dropShadow: {
                            enabled: true,
                            color: '#111',
                            top: -1,
                            left: 3,
                            blur: 3,
                            opacity: 0.2
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: true,
                                    total: {
                                        showAlways: true,
                                        show: true
                                    }
                                }
                            }
                        }
                    },
                    labels: [],
                    legend: {
                        show: false
                    },
                    dataLabels: {
                        dropShadow: {
                            blur: 3,
                            opacity: 0.8
                        }
                    },
                    responsive: [{
                        breakpoint: 480,
                        options: {
                            chart: {
                                width: 350
                            },
                            legend: {
                                position: 'bottom'
                            }
                        }
                    }],
                    tooltip: {
                        fillSeriesColor: true
                    },
                    title: {
                        text: this.chartTitle
                    }
                },
                series: []
            }
        },
        watch: {
            statusCounts(newValue) {
                this.updateChart(newValue)
            }
        },
        created() {
            this.updateChart(this.statusCounts)
        },
        methods: {
            updateChart(statusCounts) {
                statusCounts.forEach(item => {
                    const { status, count } = item
                    if (this.statusCountsMap.has(status)) {
                        this.statusCountsMap.set(status, this.statusCountsMap.get(status) + count)
                    } else {
                        this.statusCountsMap.set(status, count)
                    }
                })

                const labels = Array.from(this.statusCountsMap.keys())
                this.chartOptions.labels = labels
                this.series = Array.from(this.statusCountsMap.values())
                this.chartOptions.colors = labels.map(label => MSG_STATUS_COLORS[label])
            }
        }
    }
</script>
